import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {

  @Output() onFileSelected: EventEmitter<any> = new EventEmitter();

  @Output() onMultipleFileSelected: EventEmitter<any> = new EventEmitter();

  singleLogViewer: boolean = false;

  constructor() { }

  ngOnInit() {
  }
  file:any;
  fileChanged(e) {
      this.file = e.target.files[0];

      console.log(this.file);
      this.uploadDocument(this.file);


  }

  uploadDocument(file) {
    var reader = new FileReader();
    reader.onload = () => {
        console.log(reader.result);
        this.onFileSelected.emit(reader.result);

    };
    reader.readAsText(file);
}
 files:File[] = []; 
fileChangedMultiple(event){
  console.log(event);
if(event.target.files.length){
    for(let i=0 ; i < event.target.files.length ;i++){ 
      this.files.push(<File>event.target.files[i]);
    }
  }

  for (let index = 0; index < this.files.length; index++) {
    const file = this.files[index];
    //console.log(file);
    //this.readFile(file);
  }

  this.onMultipleFileSelected.emit( this.files);

  //console.log(this.files);
}

readFile(file: File) {
    var reader = new FileReader();
    reader.onload = () => {
        console.log(reader.result);
    };
    reader.readAsText(file);
}




}
